import type { PrivateContent } from "../../services/api";
import {
  isYouTubeLongFormMentionMode,
  type ContentShortFormFields,
} from "../../utils/contentShortForm";

/** Earliest calendar day shown on Mi contenido daily trends charts (dailyMetrics collectedAt). */
export const MI_CONTENIDO_DAILY_TRENDS_CHART_MIN_DATE = "2026-06-25";

/** Short-form platforms where dailyMetrics charts start at {@link MI_CONTENIDO_DAILY_TRENDS_CHART_MIN_DATE}. */
export function appliesDailyMetricsMinDateFilter(
  content: ContentShortFormFields | null | undefined,
): boolean {
  if (!content) return false;
  if (content.source === "instagram" || content.source === "tiktok" || content.source === "facebook") return true;
  if (content.source === "youtube") return !isYouTubeLongFormMentionMode(content);
  return false;
}

export type MiContenidoDailyTrendsMetric = "views" | "interactions";

export function effectiveDailyTrendsStartDate(scopeStartDate: string): string {
  return scopeStartDate > MI_CONTENIDO_DAILY_TRENDS_CHART_MIN_DATE
    ? scopeStartDate
    : MI_CONTENIDO_DAILY_TRENDS_CHART_MIN_DATE;
}

export function filterDailyTrendRowsForChart<
  T extends { date: string },
>(rows: T[], scopeStartDate: string, scopeEndDate: string): T[] {
  const minDate = effectiveDailyTrendsStartDate(scopeStartDate);
  return rows.filter((row) => row.date >= minDate && row.date <= scopeEndDate);
}
